import ClientsList from "../views/ClientsList"

import ClientsOverview from "../views/ClientsOverview.vue"

import ClientsPolicies from "../views/ClientsPolicies"
import ClientsObjects from "../views/ClientsObjects"
import ClientsLogs from "../views/ClientsLogs"

import ClientsCreate from "../views/ClientsCreate.vue"

export default [
	{
		path: "/:tenantId/clients/",
		component: ClientsList,
		name: "ClientsList",
		meta: { featureId: "clients" },
		props: true
	},
	{
		path: "/:tenantId/clients/detail/:id/overview/:clientType",
		component: ClientsOverview,
		name: "ClientDetail",
		meta: { featureId: "clients" },
		props: true
	},
	{
		path: "/:tenantId/clients/detail/:id/policies/:clientType",
		component: ClientsPolicies,
		name: "ClientsPolicies",
		meta: { featureId: "clients" },
		props: true
	},
	{
		path: "/:tenantId/clients/detail/:id/objects/:clientType",
		component: ClientsObjects,
		name: "ClientsObjects",
		meta: { featureId: "clients" },
		props: true
	},
	{
		path: "/:tenantId/clients/detail/:id/logs/:clientType",
		component: ClientsLogs,
		name: "ClientsLogs",
		meta: { featureId: "clients" },
		props: true
	},
	{
		path: "/:tenantId/clients/create",
		component: ClientsCreate,
		name: "ClientsCreate",
		meta: { featureId: "clients" },
		props: true
	}
]
